import { atomWithStorage } from "jotai/utils";

export const panelAtom = atomWithStorage("panelExpanded", true);
